import  { useEffect, useState } from 'react'
import {Swiper,SwiperSlide} from 'swiper/react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import api from '../../api/api';
import { FaCheck, FaShoppingCart } from "react-icons/fa";
import { toast } from 'react-toastify';
import { IoIosArrowBack } from 'react-icons/io';
import { FiPlusCircle } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { motion } from "framer-motion";
import { useProfileStore } from '../../store/useUserStore';

const ItemView = () => {
    const navigate = useNavigate()
    let { id } = useParams()
    const location = useLocation()
    const [item, setItem] = useState<any>({
        images: [],
        name: "",
        description: "",
        course_type: 1,
        price: 0,
        branches: []
    })
    const searchParams = new URLSearchParams(location.search)
    const courseBranchId = searchParams.get('course_branch_id')
    const { t } = useTranslation()
    const { selectedStudent, students, homePageShow } = useProfileStore((state) => state)
    const [cartItemOptionOpen, setCartItemOptionOpen] = useState(false)
    const [innerSelectedStudent, setInnerSelectedStudent] = useState<any>(null)
    const {setLoading} = useProfileStore((state) => state)

    
    useEffect(() => {
        if (!courseBranchId) {
            return navigate("/")
        }
        getItemById()
    }, [id])

    function getItemById() {
        setLoading(true)
        api.get(`${process.env.REACT_APP_API_BASE_URL}/item/${id}?display_related=true`).then( res => {
            setLoading(false)
            console.log("res item", res.data.data)
            const data = res?.data?.data
            const related = data?.related

            setItem({
                ...data,
                related: related?.length > 4 ? related.slice(0, 4) : related,
            })
        }).catch( err => {
            setLoading(false)
            console.log("err", err)
            navigate("/")
        })
    }
    
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpanded = () => {
      setIsExpanded(!isExpanded);
    }
  
    const shortenedDescription = item.description.slice(0, 100)
  
    function handleAddToCart() {
        let studentIds: number[] = []
        if (homePageShow==="academy") {
            // from academy
            if (!innerSelectedStudent || innerSelectedStudent.length === 0) return toast.warn(t('course_view.please_select_student'))
            studentIds = [innerSelectedStudent.id]
        } else {
            // from school
            if (!selectedStudent || Object.keys(selectedStudent).length == 0) return toast.warn(t('course_view.please_select_student'))
            studentIds = [selectedStudent.id]
        }

        setLoading(true)
        api.post(`${process.env.PUBLIC_URL}/cart/add`, {
            "student_ids": studentIds,
            "type": "item",
            "id": selectedItemId,
            "quantity": 1,
            "course_branch_id": courseBranchId
        }).then(res => {
            setLoading(false)
            toast.success(t("item_view.add_to_cart"))
            console.log("res", res)
        }).catch(err =>{
            setLoading(false)
            toast.error(t("server_error"))
            console.log("err", err)
        })
    }

    const navigateBack = () => {
        if (window.history?.length && window.history.length > 1) {
            navigate(-1)
        } else {
            navigate('/', { replace: true })
        }
    }

    const [selectedItemId, setSelectedItemId] = useState<any>(null)
    function openCartItemOption(itemId: any) {
        setCartItemOptionOpen(true)
        setSelectedItemId(itemId)
    }

    return (
        <>
        <div className="pb-20 px-2">
            <div className='mb-3 grid grid-cols-3 mx-1'>
                <div><IoIosArrowBack size={28} color='#000' onClick={()=>navigateBack()}/></div>
                <div className='text-center text-lg font-medium'>{item.name}</div>
                <div></div>
            </div>
            <div className="mb-4">
                <Swiper slidesPerView={1} spaceBetween={0}>
                    {item.images.map((single: any, key: number) => (
                        <SwiperSlide key={key}>
                            <div className="flex justify-center items-center h-96 w-full bg-white">
                                <img src={single} alt="" className="object-cover h-full" />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            <div className="pb-2">
                <div className="px-4 mb-4">
                    <div className="flex justify-between items-start">
                        <div>
                            <div className="text-2xl font-normal">{item.name}</div>
                        </div>
                        <div className="flex-shrink-0 text-2xl font-medium">{`RM ${item.price}`}</div>
                    </div>
                </div>

                <div className="px-4 mb-4">
                    <div>
                        {isExpanded ? item.description : `${shortenedDescription}...`}
                    </div>
                    <button className="text-theme hover:text-theme focus:outline-none mt-2" onClick={toggleExpanded} >
                        {isExpanded ? t("item_view.view_less") : t("item_view.view_more")}
                    </button>
                </div>
            </div>

            <div className="flex justify-center mt-8">
                <button onClick={() => { openCartItemOption(id) }} className="bg-theme w-4/6 flex gap-3 text-white justify-center text-center mb-3 h-12 py-2 px-4 font-normal text-base items-center rounded-full cursor-pointer hover:bg-gray-400" >
                    <FaShoppingCart size={18} />
                    {t('item_view.add_to_cart')}
                </button>
            </div>

            <div className='grid grid-cols-2 gap-2 px-2 mt-8'>
                {item.related && item.related.map( (related:any, index:number) => (
                    <div className="p-2 px-2.5 rounded-xl mb-3 shadow-course-card" key={index}>
                        <Link to={`/item/${related.id}?course_branch_id=${id}`} className='text-base font-medium mb-2'>{related.name}</Link>
                        <Link to={`/item/${related.id}?course_branch_id=${id}`} className='w-full'>
                            <div className="py-2 text-center">
                                {item.images && item.images.length > 0 ? (
                                    <img style={{ height: "10rem" }} className="rounded-2xl inline-block" alt="" src={item.images[0]}/>
                                ):(
                                    <img style={{ height: "10rem" }} className="rounded-2xl inline-block" alt="" src="/assets/img/products/product1.png"/>
                                )}
                            </div>
                        </Link>
                        <Link to={`/item/${related.id}?course_branch_id=${id}`} className="flex justify-between">
                            <div className='text-base font-medium'>RM {related.price}</div>
                            <div className='text-sm font-normal text-gray-400 self-end'>{t('item_view.stock')}: {related.stock}</div>
                        </Link>
                        <div className="flex justify-center">
                            <div onClick={() => { openCartItemOption(related.id) }} className="justify-content-center bg-theme w-full flex gap-2 text-white text-center mt-3 py-2 px-2 items-center rounded-full cursor-pointer hover:bg-gray-400">
                                <FiPlusCircle size={18} />
                                <div>{t('item_view.add_to_cart')}</div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {cartItemOptionOpen && (
                <div className="fixed inset-0 z-10 bg-black bg-opacity-50 flex justify-center items-end" onClick={() => setCartItemOptionOpen(false)} >
                    <motion.div
                        initial={{ y: "100%" }}
                        animate={{ y: 0 }}
                        exit={{ y: "100%" }}
                        transition={{ stiffness: 100 }}
                        className="w-full max-w-[648px] bg-white shadow-2xl rounded-t-3xl px-4 pt-4 pb-24"
                        onClick={(e) => e.stopPropagation()}
                    >

                    {/* Coming from Academy where no students selected */}
                    {(homePageShow === "academy") && (
                    <div className="pb-2">
                        <div className='mb-1 text-base font-medium'>{t('course_view.choose_student')} <span className='text-gray-500 italic font-normal'>{t('course_view.choose_1_only')}</span></div>
                        <div className="grid grid-cols-2 gap-2 mt-2">
                            {students && students.map((student:any) => (
                            <div key={student.id} className={`flex items-center gap-2 px-2 py-2 rounded-lg w-full border ${innerSelectedStudent?.id == student.id ? " bg-theme  text-white " : "bg-gray-100 text-black"} transition duration-300`} onClick={() => setInnerSelectedStudent(student)} >
                                {innerSelectedStudent?.id == student.id ? (
                                    <FaCheck className="w-5 h-5 " />
                                ) : (
                                    <div className="w-5 h-5  border border-black rounded-md"></div>
                                )}
                                <div className="truncate ">{student.name}</div>
                            </div>
                            ))}
                        </div>
                    </div>
                    )}

                    {/* Coming from School where student selected */}
                    {(homePageShow === "school") && (
                    <div className="pb-2">
                        <div className='mb-1 text-base font-medium'>{t('course_view.choose_student')}</div>

                        <div className="grid grid-cols-2 gap-2 mt-2">
                            {students && students.map((student:any) => (
                            <div key={student.id} className={`flex items-center gap-2 px-2 py-2 rounded-lg w-full border ${selectedStudent?.id == student.id ? " bg-theme  text-white " : "bg-gray-100 text-black"} transition duration-300`}>
                                {selectedStudent?.id == student.id ? (
                                    <>
                                    <div className="flex-shrink-0 w-5 h-5 border-2 border-white rounded-full flex items-center justify-center">
                                        <div className="w-2.5 h-2.5 bg-white rounded-full"></div>
                                    </div>
                                    <div className="pl-1 truncate">{student.name}</div>
                                    </>
                                ) : (
                                    <>
                                    <div className="flex-shrink-0 w-5 h-5 border-2 border-gray-400 rounded-full flex items-center justify-center">
                                        <div className="w-2.5 h-2.5 rounded-full"></div>
                                    </div>
                                    <div className="pl-1 truncate text-gray-400">{student.name}</div>
                                    </>
                                )}
                            </div>
                            ))}
                        </div>
                    </div>
                    )} 

                    <button onClick={() => handleAddToCart()} className="bg-theme w-full flex gap-3 text-white justify-center text-center h-12 py-2 px-4 font-normal text-base items-center rounded-full cursor-pointer hover:bg-gray-400l mt-3" >
                        <FaShoppingCart size={18} />
                        {t('course_view.add_to_cart')}
                    </button>
                    </motion.div>
                </div>
            )}

        </div>
        </>
    )
}

export default ItemView